import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/authContext";

// Decide con el rol CONFIRMADO por el servidor (authContext lo pide a /login/me,
// que devuelve el tipo del JWT firmado), nunca con el `user` de localStorage, que
// se puede editar desde la consola. Mientras se confirma no se pinta nada.
// Ojo: esto solo evita enseñar pantallas; quien protege los datos es el backend
// (cada endpoint exige su rol desde el JWT).
export default function PrivateRoute({ children, allowedRoles }) {
  const { user, verificado } = useAuth();

  if (!verificado) {
    return (
      <div style={{ padding: 40, textAlign: "center", color: "#94a3b8", fontFamily: "system-ui, sans-serif" }}>
        Cargando…
      </div>
    );
  }

  if (!user) {
    // Si no hay usuario logueado, redirige al login
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.tipo)) {
    // Si el rol del usuario no está permitido, redirige a unauthorized
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
